import { get, head } from 'lodash';

export const isUserCA = (state) => state.user.sub_segment === 'CA';
export const getUserId = (state) => state.user.id;
export const getUser = (state) => state.user;

export const getCustomerId = (state) => {
	const {
		user: { customers = [] },
	} = state;
	const customerId = get(head(customers), 'customer_id');
	return customerId;
};
